import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <IconButton sx={{ width: 45, height: 45 }} onClick={() => navigate(-1)}>
      <ArrowBackIcon />
    </IconButton>
  );
}
